//购物车页面
<template>
	<div class="sld_cart_index">
		<div style="margin-bottom: 0px;padding-bottom: 70px;" class="cart_content" v-if="cartData.data &&
			((cartData.data.invalidList &&
				cartData.data.invalidList.length > 0) ||
				(cartData.data.storeCartGroupList &&
					cartData.data.storeCartGroupList.length > 0))
			">
			<!-- 购物车列表顶部标题 start-->
			<div class="cart_title flex_row_start_center">
				<div class="cart_title_pre flex_row_start_center" v-if="cartData.data.storeCartGroupList.length > 0">
					<div class="select" @click="changeSelectState('all', cartData.data.checkedAll)" style="margin-right: 10px;">
						<!-- <myCheckBox :checked="cartData.data.checkedAll" :disabled="cartData.data.lackAll"></myCheckBox> -->
						<div class="checkboxbox" >
							<input type="checkbox" :checked="cartData.data.checkedAll" :disabled="cartData.data.lackAll">
							<span class="checkbox-custom"></span>
						</div>
					</div>
					<span>{{ L['全选'] }}</span>
					<!-- <span>{{ L['全选'] }}<text v-if="cartData.data.totalCheck">（{{
						cartData.data.totalCheck }}）</text></span> -->
				</div>
				<div class="cart_title_pre">
					<span>{{ L['商品'] }}</span>
				</div>
				<div class="cart_title_pre">
					<span>{{ L['单价'] }}</span>
				</div>
				<div class="cart_title_pre">
					<span>{{ L['数量'] }}</span>
				</div>
				<div class="cart_title_pre">
					<span>{{ L['小计'] }}</span>
				</div>
				<!-- <div class="cart_title_pre">
					<span>{{ L['积分'] }}</span>
				</div> -->
				<div class="cart_title_pre">
					<span>{{ L['操作'] }}</span>
				</div>
			</div>
			<!-- 购物车列表顶部标题 end-->
			<!-- 购物车列表 start -->
			<div class="cart_lists" v-show="cartData.data">
				<div class="cart_lists_pre" v-for="(cartGroupItem, cartGroupIndex) in cartData.data
					.storeCartGroupList" :key="cartGroupIndex">
					<!-- 店铺信息 start -->
					<!-- <div class="store_info flex_row_start_center"> -->
						<!-- 可选择 -->
						<!-- <div class="select"> -->
							<!-- 全部无货，不可选择 -->
							<!-- <img src="@/assets/cart/not_sel.png" alt="" class="store_sel" v-if="cartGroupItem.lackAll" />
							<div v-else @click="changeSelectState('store', cartGroupItem.checkedAll, cartGroupItem)"
								style="margin-right: 20px;">
								<myCheckBox :checked="cartGroupItem.checkedAll"></myCheckBox>
							</div>
						</div>
						<router-link target="_blank" :to="`/store/index?vid=${cartGroupItem.storeId}`"
							class="store_des flex_row_start_center cursor_pointer">
							<span>{{ cartGroupItem.storeName }}</span>
							<img src="@/assets/cart/right_down.png" alt="" />
						</router-link>
						<div class="store_kefu" @click="kefu(cartGroupItem)">
							<dynaIcon src="goods/server.png" color="--color_main" width="18" height="18">
							</dynaIcon>
						</div>
						<div v-show="cartGroupItem.hasCoupon" class="store_coupons" :class="{ active: cartGroupItem.showCoupon }">
							<div class="store_coupons_bg" @click="openCouponModel(cartGroupItem.storeId, cartGroupIndex, 'open')">
								<dynaIcon src="cart_coupons_list.png" width="82" height="26" color="--color_main" class="img">
								</dynaIcon>
								<p class="cp_name">优惠券</p>
								<em>></em>
							</div>
							<div v-if="cartGroupItem.showCoupon" class="store_coupons_list">
								<div class="store_coupons_close flex_row_end_center">
									<img src="@/assets/buy/close.png" @click="closeCouponModel(cartGroupIndex)" />
								</div>
								<div class="model_coupon_list">
									<CouponItem v-for="(couponItem, couponIndex) in couponList.data.list" :key="couponIndex"
										:class="sld_coupon_item" coupon_type="small" :coupon_item="couponItem"
										@refreshCouponList="openCouponModel(null, null, 'get')">
									</CouponItem>
								</div>
								<div class="flex_row_end_center sld_pagination sld_paginations sld_page_bottom" v-if="couponList.data.pagination &&
									couponList.data.pagination.total
									">
									<el-pagination @current-change="handleCurrentChangeCoupon" v-model:currentPage="curCouponPage"
										:page-size="couponPageSize" layout="prev, pager, next, jumper"
										:total="couponList.data.pagination.total" :hide-on-single-page="true">
									</el-pagination>
								</div>
								<div class="rotate_circle"></div>
							</div>
						</div>

					</div> -->
					<!-- 店铺信息 end -->
					 <!-- 优惠券 start -->
					<div v-if="cartGroupItem.couponList.length" class="coupon_tips flex_row_start_center">
						<div class="coupon_list" v-for="(couponItem, couponIndex) in cartGroupItem.couponList.slice(0, 3)" :key="couponIndex">
							<div class="coupon_item" v-if="couponItem.couponType == '1' || couponItem.couponType == '3'">
								{{ L['满'] }}{{ couponItem.limitQuota }}{{ L['元减'] }}{{ couponItem.publishValue }}{{ L['元券'] }}
							</div>
							<div class="coupon_item" v-if="couponItem.couponType == '2'">
								{{ L['满'] }}{{ couponItem.limitQuota }}{{ L['元打'] }}{{ couponItem.publishValue }}{{ L['折券'] }}</div>
							<!-- <div class="coupon_item">{{ L['满1000减50'] }}</div> -->
						</div>
						<span class="coupon_more pointer" @click="openCouponBox">{{ L['更多 >'] }}</span>
						<el-dialog v-model="couponVisible" title="优惠券" width="950px" center custom-class="coupon_more_custom">
							<div class="coupon_container">
								<div class="coupon_item_more" v-for="(couponItem, couponIndex) in cartGroupItem.couponList" 
								:key="couponIndex" 
								:class="{ 'last-in-row': isLastInRow(couponItem) }"
								@click="getCouponInfo(couponItem)"
								>
									<div class="coupon_more_item flex_row_between_center">
										<div class="more_left flex_column_start_start">
											<div class="more_top flex_row_start_center">
												<span class="coupon_mon" v-if="couponItem.couponType == '1' || couponItem.couponType == '3'">￥{{couponItem.publishValue }}</span>
												<span class="coupon_mon" v-if="couponItem.couponType == '2'">{{couponItem.publishValue}}折</span>
												<span class="coupon_lim">满{{couponItem.limitQuota}}{{ L['可用'] }}</span>
											</div>
											<span class="more_center">{{ couponItem.couponName }}</span>
											<span class="more_bottom">{{ L['有效期：'] }}{{ couponItem.effectiveStart.slice(0, 10).replace(/-/g, '.') }}{{ L['～'] }}{{ couponItem.effectiveEnd.slice(0, 10).replace(/-/g, '.') }}</span>
										</div>
										<div class="more_right" :class="{ no_receive: couponItem.receiveFlag == 1}">
											<!-- 领取前 -->
											 <div v-if="couponItem.receiveFlag == 0">{{ L['领取'] }}</div>
											<!-- <img src="../../assets/cart/coupon_no.png" alt="" v-if="couponItem.receiveFlag == 0"> -->
											<!-- 领取后 -->
											<div v-if="couponItem.receiveFlag == 1">{{ L['已领取'] }}</div>
											<!-- <img src="../../assets/cart/coupon_yes.png" alt="" v-if="couponItem.receiveFlag == 1"> -->
										</div>
									</div>
								</div>
							</div>
							
							<!-- <template #footer>
								<div class="dialog-footer">
									<el-button type="primary" @click="closeCouponInfo(couponItem)">{{ L['确定'] }}</el-button>
								</div>
							</template> -->
						</el-dialog>
					</div>
					<!-- 商品信息 start -->
					<div class="goods_con" v-for="(promotionCartGroupItem,
						promotionCartGroupIndex) in cartGroupItem.promotionCartGroupList" :key="promotionCartGroupIndex">
						<!-- 满减活动 start -->
						<div class="full_reduc_activity flex_row_start_center" v-show="promotionCartGroupItem.promotionDes">
							<span class="full_reduc_title">{{ L['满减'] }}</span>
							<div class="full_reduc_des" v-html="promotionCartGroupItem.promotionDes"></div>
						</div>
						<!-- 满减活动 end -->
						<!-- 商品列表 start -->
						<div class="goods_list" style="display: block;">
							<div class="flex_column_start_center"
								:class="{ active: cartItem.isChecked && cartItem.productState != 3 }"
								v-for="(cartItem, cartIndex) in promotionCartGroupItem.cartList" :key="cartIndex">
								<!-- 限时抢购 -->
								 <div class="goods_type flex_row_start_center" v-if="cartItem.promotionType">
									<div class="goods_type_content flex_row_center_center" v-if="cartItem.promotionType=='106'">
										<img class="type_pic" src="../../assets/cart/colock_white.png" alt="">
										<span class="type_title">{{ L['限时抢购'] }}</span>
									</div>
									<!-- 预售 -->
									<div class="goods_type_content goods_yushou flex_row_start_center" v-if="cartItem.promotionType=='103'">
										<img class="type_pic" src="../../assets/cart/clock_gold.png" alt="">
										<span class="type_title title_yushou">{{ L['预售'] }}</span>
									</div>
									<div class="goods_type_status flex_row_center_center" v-if="cartItem.promotionType=='106' || cartItem.promotionType=='103'">{{ L['活动进行中'] }}</div>
								</div>
								<!-- 商品 -->
								<div class="goods_pre flex_row_start_center">
										<!-- 可选择 -->
									<div class="goods_pre_sel" :class="{ no_cursor: cartItem.productState == 3 }">
										<!-- 全部无货，不可选择 -->
										<img src="@/assets/cart/not_sel.png" alt="" class="store_sel" v-if="cartItem.productState == 3" />
										<div v-else @click="changeSelectState('goods', cartItem.isChecked, cartItem)"
											style="margin-right: 20px;">
											<!-- <dynaIcon src="cart/sel.png" width="15" height="14" color="--color_main" v-if="cartItem.isChecked"
												style="cursor: pointer;"></dynaIcon>
											<img src="@/assets/cart/not_sel.png" class="store_sel" v-else /> -->
											<!-- <myCheckBox :checked="cartItem.isChecked"></myCheckBox> -->
											<div class="checkboxbox" v-if="cartItem.productState == 1 && (cartItem.promotionType == 0 || cartItem.promotionType == 106) && cartItem.productStock !=0">
												<input type="checkbox" :checked="cartItem.isChecked">
												<span class="checkbox-custom"></span>
											</div>
											<div class="checkboxboxInvalid" v-else>
												<input type="checkbox" :disabled="isDisabledInvalidSle">
												<span class="checkbox-custom-invalid"></span>
											</div>
											
										</div>
									</div>

									<!-- 商品信息 -->
									<div :style="{
										backgroundImage: 'url(' + cartItem.productImage + ')'
									}" class="goods_img" :class="{ no_stock_img: cartItem.productStock == 0 }"
										@click="goGoodsDetail(cartItem.productId)"></div>
									<div class="goods_des" :class="cartItem.specValues
										? 'flex_column_between_start'
										: 'flex_column_center_start'
										" >
										<p @click="goGoodsDetail(cartItem.productId)" class="goods_name" :class="{ no_stock_name: cartItem.productStock == 0 }">
											<!-- <span v-for="(item,index) in cartItem.promotionList" :key="index"> -->
												<img class="new_goods" src="../../assets/cart/new_pro.png" alt="" v-if="cartItem.promotionType ==408">
												<span class="new_goods_item" v-if="cartItem.promotionType ==408"></span>
												<span class="first_order" v-if="cartItem.promotionType == 501">{{ L['专享'] }}</span>
												<span class="first_order" v-if="cartItem.promotionType == 107">{{ L['预约'] }}</span>
												<span class="first_order" v-if="cartItem.promotionType == 103">{{ L['预售'] }}</span>
												<span class="first_order" v-if="cartItem.promotionType == 106">{{ L['限时'] }}</span>
											<!-- </span> -->
											<text >{{ truncateText(cartItem.productShortTitle,50) }}</text>
										</p>
										<!-- 选择配置 -->
										<p class="goods_spec" @click="openSpecBox(cartItem)" :class="{ no_stock_spec: cartItem.productStock == 0 }">
											<text v-if="cartItem.specValues">{{ truncateText(cartItem.specValues,20) }}</text>
											<text v-else>{{ L['默认'] }}</text>
											<img class="arrow_down" src="../../assets/cart/arrow_down.png" alt="">
										</p>
									</div>
									<!-- 单价 -->
									<div class="goods_price_prom">
										<div class="goods_price" :class="{ no_stock_price: cartItem.productStock == 0 }">
											￥{{ cartItem.productPrice }}
										</div>
										<!-- <div v-if="cartItem.promotionList &&
											cartItem.promotionList.length > 0">
											<el-popover width="300px" v-model="cartItem.promotionModel" @show="promotionShow(cartItem)">
												<template #reference>
													<div v-if="cartItem.promotionList.length > 0" class="promotion cursor_pointer">
														{{
															L['促销']
														}}<i class="iconfont iconziyuan11-copy"></i>
													</div>
												</template>
												<div class="option_promotion">
													<el-radio-group v-model="curPromotion" @change="changePromotion($event, cartItem)"
														text-color="#333333" fill="#FF0000">
														<el-radio v-for="(promotionItem,
															promotionIndex) in cartItem.promotionList" :key="promotionIndex" :label="promotionItem.goodsPromotionId"
															class="promotion_radio">
															<p v-html="promotionItem.promotionDes"></p>
														</el-radio>
													</el-radio-group>
													<div class="promotion_btn flex_row_center_center">
														<span @click="selPromotion()">{{ L['确定'] }}</span>
														<span @click="cancelPromotion()">{{
															L['取消']
														}}</span>
													</div>
												</div>
											</el-popover>
										</div> -->
									</div>
									<!-- 数量 -->
									<div class="goods_num flex_column_center_center" >
										<div class="goods_edit_nem flex_row_center_center" :class="{ no_stock_num: cartItem.productStock == 0 }">
											<span @click="editNum('reduce', cartItem)" :style="{color:cartItem.buyNum < cartItem.productStock && cartItem.buyNum !=1 ? '#000000' : '#BDBDBD' }">-</span>
											<input :class="{ no_stock_num: cartItem.productStock == 0 }"  type="number" v-model="cartItem.buyNum" @input="editNum('edit', cartItem, $event)"
												@blur="editNum('blur', cartItem, $event)" @keyup="handleKey" />
											<span @click="editNum('add', cartItem)" :style="{color:cartItem.buyNum < cartItem.productStock ? '#000000' : '#BDBDBD' }">+</span>
										</div>
										<!-- <div class="goods_stocks" v-if="cartItem.productState != 3">
											{{ L['库存'] }} {{ cartItem.productStock }}
										</div>
										<div class="goods_stocks goods_stocks_no" v-if="cartItem.productState == 3">
											{{ L['库存不足'] }}
										</div>
										<div class="goods_stocks goods_stocks_red" v-if="cartItem.buyNum > cartItem.productStock">
											{{ L['剩余'] }} {{ cartItem.productStock }} {{ L['件'] }}
										</div> -->
									</div>
									<!-- 小计 -->
									<div class="subtotal" :class="{ no_stock_subtotal: cartItem.productStock == 0 }">
										￥{{
											cartItem.buyNum
											? (
												Number(cartItem.buyNum) * cartItem.productPrice
											).toFixed(2)
											: cartItem.productPrice.toFixed(2)
										}}
									</div>
									<!-- 积分 -->
									<!-- <div class="goods_score">13000</div> -->
									<!-- 操作 -->
									<div class="goods_btn" >
										<!-- <span class="goods_collect" @click="moveCartGoods(cartItem.cartId)" v-if="token">{{
											L['移入收藏夹']
										}}</span> -->
										<el-popconfirm :title="L['确认删除商品？']" @confirm="delCartGoods('goods', cartItem)"
											:confirmButtonText="L['删除']" :cancelButtonText="L['取消']" :hide-icon="true" placement="top">
											<template #reference>
												<span class="goods_del" :class="{ no_stock_del: cartItem.productStock == 0 }">{{ L['删除'] }}</span>
											</template>
										</el-popconfirm>
									</div>
								</div>
								<!-- 商品是否存在 -->
								<div class="goods_invalid flex_row_start_center" >
									<span class="invalid_item" v-if="cartItem.promotionType == 103">{{ L['预售商品请在商品详情页购买'] }}</span>
									<span class="invalid_item" v-if="cartItem.promotionType == 107">{{ L['预约商品请在商品详情页购买'] }}</span>
									<span class="invalid_item" v-if="cartItem.promotionType == 501">{{ L['首单专享价商品请在商品详情页购买'] }}</span>
									<span class="invalid_item item_color_title" v-if="cartItem.productStock == 0">{{ L['请重新选择商品规格'] }}
										<span class="item_man" @click="openSpecBox(cartItem)">{{ L['重选'] }}</span>
									</span>
									<!-- <span class="invalid_item">{{ L['商品已下架'] }}</span> -->
								</div>
								<!-- 选配 -->
								 <div class="accessory_sel flex_row_start_start" v-if=cartItem.priceIncreasePurchase.length>
									<div class="accessory_sel_title">{{ L['已选配：'] }}</div>
									<div class="accessory_sel_content flex_column_start_center">
										<div class="goods_item" v-for="(priceIncreasePurchaseItem,priceIncreasePurchaseIndex) in cartItem.priceIncreasePurchase" :key="priceIncreasePurchaseIndex">
											<div class="flex_row_start_center">
												<!-- 选配商品 -->
												<p class="goods_name">{{ truncateText(priceIncreasePurchaseItem.productShortTitle,20) }}</p>
												<!-- 单价 -->
												<div class="goods_price">￥{{ priceIncreasePurchaseItem.productPrice }}</div>
												<!-- 数量 -->
												<div class="goods_num flex_column_center_center">
													<div class="goods_edit_nem flex_row_center_center">
														<span @click="editNum('reduce', priceIncreasePurchaseItem)" :style="{color:priceIncreasePurchaseItem.buyNum < priceIncreasePurchaseItem.productStock && priceIncreasePurchaseItem.buyNum !=1 ? '#000000' : '#BDBDBD' }">-</span>
														<input type="number" v-model="priceIncreasePurchaseItem.buyNum" @input="editNum('edit', priceIncreasePurchaseItem, $event)"
															@blur="editNum('blur', priceIncreasePurchaseItem, $event)" @keyup="handleKey" />
														<span @click="editNum('add', priceIncreasePurchaseItem)" :style="{color:priceIncreasePurchaseItem.buyNum < priceIncreasePurchaseItem.productStock ? '#000000' : '#BDBDBD' }">+</span>
													</div>
												</div>
												<!-- 小计 -->
												<div class="subtotal">
													￥{{
														priceIncreasePurchaseItem.buyNum
														? (
															Number(priceIncreasePurchaseItem.buyNum) * priceIncreasePurchaseItem.productPrice
														).toFixed(2)
														: priceIncreasePurchaseItem.productPrice.toFixed(2)
													}}
												</div>
												<!-- 积分 -->
												<!-- <div class="goods_score">13000</div> -->
											</div>
										</div>
									</div>
								</div>
								 <!-- 赠品 -->
								 <div class="goods_gifts flex_row_start_center" v-if=cartItem.gifts>
									<div class="goods_gifts_content flex_row_start_center">
										<div class="gifts_title">{{ L['赠品'] }}</div>
										<div class="gifts_content flex_column_start_start">
											<div class="gifts_item" v-for="(giftsItem,giftsIndex) in cartItem.gifts" :key="giftsIndex">
												<div class="flex_row_start_center">
													<!-- 赠品图片 -->
													 <img class="gifts_pic" :src="giftsItem.mainImageUrl" alt="">
													 <!-- 赠品标题 -->
														<span class="gifts_name">{{truncateText(giftsItem.productShortTitle,20) }}</span>
														<!-- 赠品单价、数量 -->
														<span class="gifts_name">￥{{giftsItem.productPrice}}</span>
														<span class="gifts_name" >x</span>
														<span class="gifts_name" >{{giftsItem.count}}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								 <!-- 增值服务 -->
								 <div class="add_service flex_row_start_start" v-if=cartItem.isAddIncrements >
									<div class="add_service_title">{{ L['增值服务：'] }}</div>
									<div class="add_service_content flex_column_start_start">
										<div v-if="cartItem.increments.length">
											<div class="add_item" v-for="(incrementItem,incrementIndex) in cartItem.increments" :key="incrementIndex">
												<div class="flex_row_start_center">
													<!-- 增值服务标题 -->
													<span class="add_name">{{ L[truncateText(incrementItem.productShortTitle,20)] }}</span>
													<!-- 增值服务单价 -->
													<span class="add_name">￥{{ L[incrementItem.productPrice] }}</span>
												</div>
											</div>
										</div>
										<span v-else class="add_no" >{{ L['暂无选择商品'] }}</span>
									</div>
									<div class="sel_buy pointer" @click="openAddSer(cartItem)">{{ L['选购'] }}</div>
								</div>
							</div>
						</div>
						<!-- 商品列表 end -->
					</div>
					<!-- 商品信息 end -->
				</div>
				<!-- 预售商品 start -->
				<div class="invalid_goods" v-if="cartData.data.invalidList && cartData.data.invalidList.length > 0
					">
					<!-- <div class="invalid_goods_title">
						<span>{{ L['失效商品'] }}</span>
						<span v-if="token && cartData.data.invalidList.length > 0" @click="clearInvalidGoods">{{
							L['清空'] }}</span>
					</div> -->
					<div class="invalid_goods_list">
						<div class="invalid_goods_pre flex_colunm_start_start"
							v-for="(invalidItem, invalidIndex) in cartData.data.invalidList" :key="invalidIndex">
							<!-- <span class="invalid_tips">{{ L['失效'] }}</span> -->
							 <div class="flex_row_start_center">
								<div class="invalid_goods_pre_sel">
									<div class="checkboxboxInvalid">
										<input type="checkbox" :disabled="isDisabledInvalidSle">
										<span class="checkbox-custom-invalid"></span>
									</div>
								</div>
								<div :style="{
									backgroundImage: 'url(' + invalidItem.productImage + ')'
								}" class="invalid_img"></div>
								<div class="invalid_des">
									<p class="invalid_name">{{ invalidItem.productShortTitle }}</p>
									<p class="invalid_spec">{{ invalidItem.specValues }}</p>
								</div>
								<div class="invalid_price">￥{{ invalidItem.productPrice }}</div>
								<div class="invalid_num flex_column_center_center">
									<div class="invalid_edit_num flex_row_center_center">
										<span>-</span>
										<input type="number" disabled v-model="invalidItem.buyNum" />
										<span>+</span>
									</div>
								</div>
								<div class="invalid_subtotal">￥{{ invalidItem.subtotal }}</div>
								<div class="invalid_btn">
									<!-- <span class="invalid_del" @click="delCartGoods('goods', invalidItem)">{{ L['删除']
									}}</span> -->
									<el-popconfirm :title="L['确认删除商品？']" @confirm="delCartGoods('goods', invalidItem)"
										:confirmButtonText="L['删除']" :cancelButtonText="L['取消']" :hide-icon="true" placement="top">
										<template #reference>
											<span class="invalid_del">{{ L['删除'] }}</span>
										</template>
									</el-popconfirm>
								</div>
							 </div>
							 <!-- 商品是否存在 -->
							<div class="goods_invalid flex_row_start_start" v-if="invalidItem.productState ==2">
								<span class="invalid_item" >{{ L['商品已下架'] }}</span>
							</div>
						</div>
						
					</div>
				</div>
				<!-- 失效商品 -->
			</div>
			<!-- 购物车列表 end -->
			<!-- 操作按钮 start -->
			<div class="options_btn flex_row_between_center" ref="optionsBtn">
				<div class="options_btn_left flex_row_start_center">
					<div class="options_sel flex_row_start_center" v-if="cartData.data.storeCartGroupList.length > 0"
						@click="changeSelectState('all', cartData.data.checkedAll)">
						<!-- <dynaIcon src="cart/sel.png" width="15" height="14" color="--color_main" v-if="cartData.data.checkedAll"
							style="cursor: pointer;"></dynaIcon>
						<img src="@/assets/cart/not_sel.png" alt="" class="store_sel" v-else /> -->
						<!-- <myCheckBox :checked="cartData.data.checkedAll"></myCheckBox> -->
						<div class="checkboxbox">
							<input type="checkbox" :checked="cartData.data.checkedAll">
							<span class="checkbox-custom"></span>
						</div>
						<span class="sel_text">{{ L['全选'] }}</span>
					</div>
					<div class="del_all cursor_pointer" @click="delBatchGoods" v-if="cartData.data.storeCartGroupList.length > 0">
						{{ L['删除'] }}
					</div>
					<div class="del_all cursor_pointer" @click="moveCartGoods" v-if="cartData.data.storeCartGroupList.length > 0">
						{{ L['移入收藏'] }}
					</div>
					<!-- <div class="del_all cursor_pointer" @click="delBatchGoods" v-if="cartData.data.storeCartGroupList.length > 0">
						{{ L['清理购物车'] }}
					</div> -->
					<!-- <div class="del_all cursor_pointer" @click="delBatchGoods" v-if="cartData.data.storeCartGroupList.length > 0">
						{{ L['删除选中的商品'] }}
					</div> -->

				</div>
				
			<div class="options_right flex_row_start_center">
					<!-- <div class="options_line"></div> -->
					<div class="options_sel_price flex_row_start_center">
						<div class="options_all_count flex_column_start_end">
							<div class="options_total flex_row_center_center">
								<span>{{ L['总计'] }}：</span>
								<span>￥{{ cartData.data.totalAmount }}</span>
							</div>
							<div class="options_promotion flex_row_between_center">
								<div class="options_sel flex_row_between_center">
									{{ L['已选择'] }}
									<span>{{ cartData.data.totalCheck }}</span>
									{{ L['件商品'] }}
								</div>
								<!-- <div class="options_coupon flex_row_between_center">
									<span >{{ L['优惠'] }}<span >￥{{ cartData.data.totalDiscount }}</span></span>
									<el-popover placement="top" width="200" 
									popper-class="coupon_info_popover" :visible="couponInfo">
									<div class="coupon_title flex_row_between_center">
										<span>{{ L['优惠明细'] }}</span>
										<img @click="couponInfo = false" src="../../assets/cart/close_icon.png" alt="">
									</div>
									<span class="name_info_coupon">{{ L['实际优惠金额请以下单页面为准'] }}</span>
									<div class="coupon_item_info_top flex_column_start_center">
										<div class="coupon_item_info flex_row_between_center">
										<span class="name_info_coupon">{{ L['商品总计'] }}</span>
										<span class="price_coupon">¥{{ L['2895.00'] }}</span>
										</div>
										<div class="coupon_item_info flex_row_between_center">
											<span class="name_info_coupon">{{ L['优惠券'] }}</span>
											<span class="price_coupon">-¥{{ L['20.00'] }}</span>
										</div>
									</div>
									
									<div class="coupon_item_info flex_row_between_center" style="margin-top: 20px;">
										<span class="name_info_coupon">{{ L['总优惠'] }}</span>
										<span class="price_coupon">-¥{{ cartData.data.totalDiscount }}</span>
									</div>
									<div class="coupon_item_info flex_row_between_center">
										<span class="name_info_coupon_total">{{ L['合计：'] }}</span>
										<span class="price_coupon_total">¥{{ cartData.data.totalAmount }}</span>
									</div>
										<template #reference>
											<span class="promotion_detail cursor_pointer" @click="openCouponInfo">{{ L['优惠明细'] }} ></span>
										</template>
									</el-popover>
								</div> -->
							</div>
						</div>
						<!-- <div class="options_promotion flex_column_start_end">
							<span>￥{{ cartData.data.totalAmount }}</span>
							<span v-if="cartData.data.totalDiscount">￥{{ cartData.data.totalDiscount }}</span>
						</div> -->
					</div>
					<div class="go_buy cursor_pointer" :class="{ active: cartData.data.totalAmount > 0 }" @click="goBuy">
						{{ L['去结算'] }}
					</div>
				</div>
			</div>
			<!-- 操作按钮 end -->
		</div>
		<div class="cart_content_no flex_column_center_center" v-show="!cartData.data ||
			JSON.stringify(cartData.data) == '{}' ||
			(cartData.data &&
				cartData.data.invalidList &&
				cartData.data.invalidList.length == 0 &&
				cartData.data.storeCartGroupList &&
				cartData.data.storeCartGroupList.length == 0)
			">
			<img src="@/assets/cart/no_data.png" alt="" />
			<p>{{ L['这里空空如也，快去首页逛逛吧~'] }}</p>
			<span @click="goIndex" style="color: black;">{{ L['去首页 > >'] }}</span>
		</div>
		<!-- 清空失效商品 弹框 start -->
		<el-dialog title="提示" v-model="clearInvalidGoodsModel" width="20%" center top="30vh">
			<div style="margin:0 auto; text-align: center">
				{{ L['确定清空失效商品？'] }}
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="cancelClearInvalidModel">{{
						L['取 消']
					}}</el-button>
					<el-button type="primary" @click="confirmClearInvalidModel">{{
						L['确 定']
					}}</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 清空失效商品 弹框 end -->

		<!-- 删除所选商品 弹框 start -->
		<el-dialog title="提示" v-model="chosenGoodsModel" width="20%" center top="30vh" custom-class="del_custom">
			<div style="margin:0 auto; text-align: center">
				{{ L['确认删除商品？'] }}
			</div>
			<template #footer>
				<span class="dialog-footer" >
					<el-button @click="chosenGoodsModel = false">{{
						L['取 消']
					}}</el-button>
					<el-button type="primary" @click="delCartGoods('batch')">{{
						L['确 定']
					}}</el-button>
				</span>
			</template>
		</el-dialog>
		<!-- 删除所选商品 弹框 end -->

		<!-- 优惠券弹框 start -->
		<el-dialog v-model="couponModel" title="优惠券" width="832px">
			<div class="coupon_model">
				<div class="model_coupon_list">
					<CouponItem v-for="(couponItem, couponIndex) in couponList.data.list" :key="couponIndex"
						:coupon_item="couponItem" :class="sld_coupon_item" @refreshCouponList="openCouponModel(null, null, 'get')">
					</CouponItem>
				</div>
				<div class="flex_row_end_center sld_pagination sld_paginations sld_page_bottom"
					v-if="couponList.data.pagination && couponList.data.pagination.total">
					<el-pagination @current-change="handleCurrentChangeCoupon" v-model:currentPage="curCouponPage"
						:page-size="couponPageSize" layout="prev, pager, next, jumper" :total="couponList.data.pagination.total"
						:hide-on-single-page="true">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
		<!-- 优惠券弹框 end -->

		<!-- 增值服务弹框start -->
		<el-dialog v-model="addSerVisible" title="增值服务" width="950px" center custom-class="add_service_custom">
			<div class="add_ser_cpontainer">
				<div v-for="(incrServiceItem,incrServiceIndex) in incrServiceList.data" :key="incrServiceIndex">
					<div class="add_postpone">
						<div class="add_header flex_row_between_center">
							<span class="add_title">{{ incrServiceItem.increaseGroupName }}</span>
							<span class="add_info pointer"
							v-if="isAnyItemSelected(incrServiceIndex)"
							>{{ L['了解服务详情>'] }}</span>
						</div>
						<div class="add_container">
							<div class="add_item_row pointer" v-for="(incrSerInfoItem,incrSerInfoIndex) in incrServiceItem.commodityList" :key="incrSerInfoIndex" 
							:class="[
								{ 'last-in-row': isLastInRow(incrSerInfoIndex) },
								{ 'selected-item': isSelected(incrServiceIndex, incrSerInfoItem.productId) }
							]"
							@click="chooseincrService(incrServiceIndex, incrSerInfoItem)"
							>
								<div class="add_ser_item flex_row_center_center">
									<span class="add_left">{{ incrSerInfoItem.productShortTitle }}
										<span class="add_left add_left_price" style="margin-right: 10px;margin-left:25px">￥{{ incrSerInfoItem.productActivityPrice}}</span>
										<span class="add_origin_price">¥{{ incrSerInfoItem.productPrice }}</span>
									</span>
									<span class="add_tips" v-if="incrSerInfoItem.interestPoint">{{ incrSerInfoItem.interestPoint }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="confirmAddSer">{{ L['确定'] }}</el-button>
				</div>
			</template>
		</el-dialog>
		<!-- 增值服务弹框end -->

		<!-- 配置弹框start -->
		<el-dialog v-model="specVisible" title="选择配置" width="950px" center custom-class="spec_more_custom">
			<span class="spec_title">{{ L['配置'] }}</span>
			<div class="spec_main_container">
					<div class="spec_container">
						<div class="spec_item_row pointer" v-for="(SpecInfoItem,SpecInfoIndex) in SpecInfoList.data" 
						:key="SpecInfoIndex"
						@click="chooseSpec(SpecInfoItem)"
						:class="[
							{'selected-item': isSpecSelected(SpecInfoItem)},
							{ 'last-in-row': isLastInRow(SpecInfoIndex) }
						]">
							<div class="spec_item flex_row_center_center">
								<span class="spec_name">{{ SpecInfoItem.specValues}}</span>
							</div>
						</div>
					</div>
			</div>
			
			<template #footer>
				<div class="dialog-footer">
					<el-button type="primary" @click="confirmSpec">{{ L['确定'] }}</el-button>
				</div>
			</template>
		</el-dialog>
		 <!-- 配置弹框end -->

		<!-- 推荐商品 start -->
		<!-- <recommend-list></recommend-list> -->
		<!-- 推荐商品 end -->

		<!-- 登录弹框 start -->
		<SldLoginModal :visibleFlag="loginModalVisibleFlag" @closeLoingModal="closeLoingModal" />
		<!-- 登录弹框 end -->

		<!-- 底部操作悬浮框 start -->
		<div class="bottom_options" v-if="optionsBtnShow">
			<div class="bottom_options_con flex_row_between_center">
				<div class="options_btn_left flex_row_start_center">
					<div class="options_sel flex_row_start_center" @click="changeSelectState('all', cartData.data.checkedAll)">
						<!-- <img src="@/assets/cart/sel.png" alt="" class="store_sel" v-if="cartData.data.checkedAll"/> -->
						<!-- <dynaIcon src="cart/pro_yes.png" width="20" height="20" color="--color_main" v-if="cartData.data.checkedAll"
							style="cursor: pointer;"></dynaIcon>
						<img src="@/assets/cart/pro_no.png" alt="" class="store_sel" v-else />
						<span>{{ L['全选'] }}</span> -->
						<div class="checkboxbox">
							<input type="checkbox" :checked="cartData.data.checkedAll">
							<span class="checkbox-custom"></span>
						</div>
						<span class="sel_text">{{ L['全选'] }}</span>
					</div>
					<!-- <div class="del_all cursor_pointer" @click="delBatchGoods">
						{{ L['删除选中的商品'] }}
					</div> -->
					<div class="del_all cursor_pointer" @click="delBatchGoods" >
						{{ L['删除'] }}
					</div>
					<div class="del_all cursor_pointer" @click="moveCartGoods">
						{{ L['移入收藏'] }}
					</div>
					<!-- <div class="del_all cursor_pointer" @click="delBatchGoods">
						{{ L['清理购物车'] }}
					</div> -->

				</div>
				<!-- <div class="options_right flex_row_start_center">
					<div class="options_sel_num">
						{{ L['已选商品'] }}<span>{{ cartData.data.totalCheck }}</span>{{ L['件'] }}
					</div>
					<div class="options_line"></div>
					<div class="options_sel_price flex_row_start_center">
						<div class="options_all_count flex_column_start_end">
							<span>{{ L['合计'] }}：</span>
							<span v-if="cartData.data.totalDiscount">{{ L['促销减'] }}：</span>
						</div>
						<div class="options_promotion flex_column_start_end">
							<span>￥{{ cartData.data.totalAmount }}</span>
							<span v-if="cartData.data.totalDiscount">￥{{ cartData.data.totalDiscount }}</span>
						</div>
					</div>
					<div class="go_buy cursor_pointer" :class="{ active: cartData.data.totalAmount > 0 }" @click="goBuy">
						{{ L['去结算'] }}
					</div>
				</div> -->
				<div class="options_right flex_row_start_center">
					<!-- <div class="options_line"></div> -->
					<div class="options_sel_price flex_row_start_center">
						<div class="options_all_count flex_column_start_end">
							<div class="options_total flex_row_center_center">
								<span>{{ L['总计'] }}：</span>
								<span>￥{{ cartData.data.totalAmount }}</span>
							</div>
							<div class="options_promotion flex_row_between_center">
								<div class="options_sel flex_row_between_center">
									{{ L['已选择'] }}
									<span>{{ cartData.data.totalCheck }}</span>
									{{ L['件商品'] }}
								</div>
								<!-- <div class="options_coupon flex_row_between_center">
									<span >{{ L['优惠'] }}<span >￥{{ cartData.data.totalDiscount }}</span></span>
									<span>{{ L['优惠明细'] }}></span>
								</div> -->
							</div>
						</div>
						<!-- <div class="options_promotion flex_column_start_end">
							<span>￥{{ cartData.data.totalAmount }}</span>
							<span v-if="cartData.data.totalDiscount">￥{{ cartData.data.totalDiscount }}</span>
						</div> -->
					</div>
					<div class="go_buy cursor_pointer" :class="{ active: cartData.data.totalAmount > 0 }" @click="goBuy">
						{{ L['去结算'] }}
					</div>
				</div>

			</div>
		</div>
		<!-- 底部操作悬浮框 end -->
	</div>
</template>

<script>
import {
	reactive,
	getCurrentInstance,
	ref,
	watchEffect,
	onMounted,
	computed
} from 'vue'
import {
	ElMessage,
	ElDialog,
	ElButton,
	ElPopover,
	ElPopconfirm
} from 'element-plus'
import { useRouter } from 'vue-router'
import RecommendList from '../../components/RecommendList.vue'
import CouponItem from '@/components/CouponItem'
import { useStore } from 'vuex'
import SldLoginModal from '../../components/loginModal'
export default {
	name: 'CartIndex',
	components: {
		ElDialog,
		ElButton,
		ElPopover,
		ElPopconfirm,
		RecommendList,
		CouponItem,
		SldLoginModal
	},
	setup () {
		const router = useRouter()
		const { proxy } = getCurrentInstance()
		const L = proxy.$getCurLanguage()
		const store = useStore()
		const token = ref(store.state.loginFlag) //登录缓存是否登录
		const loginModalVisibleFlag = ref(false) //登录弹框是否显示，默认不显示
		const cartData = reactive({ data: store.state.cartListData }) //购物车数据信息
		const clearInvalidGoodsModel = ref(false) //清空失效商品对话框是否显示
		const delGoodsCartIds = ref('') //要删除的商品的购物车的id集
		const delType = ref('goods') //要删除的商品类型：goods：单个商品删除 batch:批量删除
		const curPromotion = ref(-1) //当前选择的商品的活动的促销的id
		const curPromotionCartItem = reactive({ data: {} }) //当前选择的要换促销的商品
		const couponModel = ref(false) //优惠券弹框是否显示
		const couponList = reactive({ data: {} }) //当前店铺优惠券列表数据
		const cartListData = reactive({ data: store.state.cartListData }) //获取vux的store中的购物车数据
		const optionsBtnTop = ref(0) //底部操作按钮元素的top值
		const windowHeight = ref(0) //屏幕元素的高度
		const optionsBtnShow = ref(false) //底部操作按钮悬浮框是否显示
		const optionsBtn = ref(null) //获取底部操作按钮元素
		const curPromotionGoodsProductId = ref('') //当前点击的促销活动的商品
		const curCouponPage = ref(1) //当前为第一页优惠券
		const couponPageSize = ref(6) //优惠券默认一页显示6条数据
		const curStoreId = ref(-1) //当前打开的优惠券弹框的店铺id
		const elementScrollTop = ref(0) //页面滚动高度
		const chosenGoodsModel = ref(false)
		const couponVisible = ref(false)
		const addSerVisible = ref(false)
		const specVisible = ref(false)
		const couponInfo = ref(false)//优惠明细是否显示
		const incrServiceList = reactive({ data: [] })
		const SpecInfoList = reactive({data: []})
		const productId = ref('') //货品id
		// const incrServicecommodityList = reactive({data:[]})
		const isDisabledInvalidSle = ref(true)
		
		onMounted(() => {
			getCartData()
			window.addEventListener('scroll', scrollHandle) //绑定页面滚动事件
		})
		//页面监听token是否更新
		watchEffect(() => {
			token.value = store.state.loginFlag
			cartData.data = store.state.cartListData
			//实时获取屏幕的高度
			windowHeight.value = document.documentElement.clientHeight

			if (optionsBtn.value != null && optionsBtn.value != undefined) {
				optionsBtnTop.value = optionsBtn.value.offsetTop
				if (optionsBtnTop.value > windowHeight.value) {
					optionsBtnShow.value = true
				} else {
					optionsBtnShow.value = false
				}
				if (elementScrollTop.value + windowHeight.value > optionsBtnTop.value) {
					optionsBtnShow.value = false
				} else {
					optionsBtnShow.value = true
				}
			}
		})

		const scrollHandle = e => {
			elementScrollTop.value = e.srcElement.scrollingElement.scrollTop
		}

		//已选择商品的件数,计算合计(未登录使用)
		const colculationOperation = () => {
			if (JSON.stringify(cartData.data) != '{}' && cartData.data != undefined) {
				cartData.data.totalCheck = 0
				cartData.data.totalAmount = 0
				cartData.data &&
					cartData.data.storeCartGroupList &&
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map(cartItem => {
								cartItem.subtotal = (
									Number(cartItem.buyNum) * cartItem.productPrice
								).toFixed(2)
								if (cartItem.isChecked == 1) {
									cartData.data.totalCheck++
									cartData.data.totalAmount += Number(cartItem.subtotal)
								}
							})
						})
					})
			}
		}

		//更新本地缓存购物车数据
		const updateLocCartData = cartData => {
			//将购物车数据更新到vuex中的store中
			store.commit('updateCartListData', cartData)
		}

		//获取购物车数据
		const getCartData = () => {
			if (store.state.loginFlag) {
				//已登录
				let params = {}
				proxy
					.$get('v3/business/front/cart/cartList', params)
					.then(res => {
						if (res.state == 200) {
						// 	if (
						// 		res.data.storeCartGroupList &&
						// 		res.data.storeCartGroupList.length
						// 	) {
						// 		res.data.storeCartGroupList.map(item => {
						// 			item.showCoupon = false
						// 		})
						// 	}
						// 	res.data.storeCartGroupList.forEach(group => {
            //   group.promotionCartGroupList.forEach(promoGroup => {
            //     promoGroup.cartList.forEach(cartItem => {
            //       if (!cartItem.cartId) {
            //         console.warn('cartItem missing cartId:', cartItem);
            //       }
            //     });
            //   });
            // });
						// // 初始化优惠券的 received 状态
						// if (cartItem.couponList) {
            //     cartItem.couponList.forEach(coupon => {
            //       coupon.received = false; // 默认设置为未领取
            //     });}
						const data = res.data;
						if (data.storeCartGroupList && data.storeCartGroupList.length) {
							data.storeCartGroupList.forEach(group => {
								group.promotionCartGroupList.forEach(promoGroup => {
									promoGroup.cartList.forEach(cartItem => {
										if (!cartItem.cartId) {
											console.warn('cartItem missing cartId:', cartItem);
										}
									
									});
								});
							});
						}
						
							cartData.data = proxy.$calculateSubtotal(res.data)
							
							acLabelMarkify()
						} else {
							ElMessage.error(res.msg)
						}
					})
					.then(() => {
						store.commit('updateCartListData', cartData.data) //将购物车数据存储到vuex的store中
					})
			} else {
				goToByPush("/login", {});
				//未登录
				cartData.data = proxy.$calculateSubtotal(cartListData.data)
				colculationOperation()
			}
			updateLocCartData(cartData.data)
		}
		

		/**编辑购物车商品数量
		 * type:编辑类型 reduce：减  edit：编辑 add：加
		 * curCartItem：编辑的当前项商品
		 * e:事件对象
		 */
		const editNum = (type, curCartItem, e) => {
			let curNumber = curCartItem.buyNum

			curCartItem.buyNum = parseInt(curCartItem.buyNum)

			switch (type) {
				case 'reduce': {
					if (curNumber > 1) {
						curCartItem.buyNum--
						curNumber--
					} else {
						curCartItem.buyNum = 1
						ElMessage(L['最低限购1件!'])
					}
					break
				}

				case 'add': {
					if (curNumber >= curCartItem.productStock) {
						ElMessage(L['数量超出购买范围！'])
						curCartItem.buyNum = curCartItem.productStock
						return
					} else {
						if (curNumber > 99998) {
							ElMessage(L['超过购买限制!'])
							curCartItem.buyNum = 99999
							return
						} else {
							curCartItem.buyNum++
							curNumber++
						}
					}
					break
				}

				case 'edit': {
					curNumber = e.currentTarget.value
					if (curNumber == 0 && curNumber != '') {
						curCartItem.buyNum = 1
						curNumber = 1
						return
					} else if (curNumber == '') {
						return
					} else {
						curNumber = curNumber.replace(/\D/g, '')
						if (
							curNumber > curCartItem.productStock &&
							curCartItem.productStock < 99999
						) {
							ElMessage(L['数量超出购买范围！'])
							curCartItem.buyNum = curCartItem.productStock
							return
						} else if (curNumber > 99999) {
							ElMessage(L['超过购买限制!'])
							curCartItem.buyNum = 99999
							return
						}
					}
					break
				}

				case 'blur': {
					if (curNumber == '') {
						curCartItem.buyNum = 1
						return
					}
				}
			}
			curNumber = curCartItem.buyNum
			if (store.state.loginFlag) {
				//已登录
				let params = {
					cartId: curCartItem.cartId, //商品购物车id
					number: curNumber //修改后商品数量
				}
				let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };

				proxy.$post('v3/business/front/cart/changeNum', params,config).then(res => {
					if (res.state == 200) {
						cartData.data = proxy.$calculateSubtotal(res.data)
						curCartItem.promotionModel = false
						closePromotionModel()
						acLabelMarkify()
						updateLocCartData(cartData.data)
					} else {
						ElMessage.error(res.msg)
					}
				})
			} else {
				//未登录
				cartData.data.storeCartGroupList &&
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map(cartItem => {
								cartItem.promotionModel = false
								if (curCartItem.productId == cartItem.productId) {
									cartItem.buyNum = curCartItem.buyNum
								}
							})
						})
					})
				colculationOperation()
				updateLocCartData(cartData.data)
			}
		}

		//当前店铺及购物车的选中状态(未登录使用)
		const curStoreCartSelChecked = () => {
			let curSelStore = [] //当前店铺未选中
			cartData.data.storeCartGroupList.map(storeItem => {
				storeItem.promotionCartGroupList.map(promotItem => {
					curSelStore = promotItem.cartList.filter(
						cartItem => cartItem.isChecked == 0
					)
					if (curSelStore.length > 0) {
						storeItem.checkedAll = false
					} else {
						storeItem.checkedAll = true
					}
				})
			})
			let curCartData = [] //当前购物车是否全选或全不选
			curCartData = cartData.data.storeCartGroupList.filter(
				storeItem => !storeItem.checkedAll
			)
			if (curCartData.length > 0) {
				cartData.data.checkedAll = false
			} else {
				cartData.data.checkedAll = true
			}
		}

		/**选中状态的更改
		 * type ： goods:商品， store :店铺 all,全部（全选或者全不选）
		 * isCheckedState：商品：当前商品的选中状态 店铺:店铺的选中状态
		 * curCartStoreGoodsId：商品：当前商品购物车信息 店铺：storeId
		 */
		const changeSelectState = (type, isCheckedState, curCartStoreGoodsId) => {
			if (store.state.loginFlag) {
				//已登录
				let cartIds = '' //商品的购物车id集
				if (type == 'goods') {
					//选择商品
					cartIds = curCartStoreGoodsId.cartId
				} else if (type == 'store') {
					//选择店铺
					cartData.data.storeCartGroupList.map(storeItem => {
						if (storeItem.storeId == curCartStoreGoodsId.storeId) {
							storeItem.promotionCartGroupList.map(promotItem => {
								promotItem.cartList.map(cartItem => {
									cartIds += cartItem.cartId + ','
								})
							})
						}
					})
					cartIds = cartIds.substring(0, cartIds.length - 1)
				} else if (type == 'all') {
					//全选或全不选
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map(cartItem => {
								cartIds += cartItem.cartId + ','
							})
						})
					})
					cartIds = cartIds.substring(0, cartIds.length - 1)
				}
				let params = {
					cartIds: cartIds, //购物车id集合
					checked: isCheckedState ? 0 : 1 //是否选中：0=全不选、1=全选中
				}
				let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
				proxy.$post('v3/business/front/cart/checkedCarts', params,config).then(res => {
					if (res.state == 200) {
						cartData.data = proxy.$calculateSubtotal(res.data)
						acLabelMarkify()
						updateLocCartData(cartData.data)
						closePromotionModel()
					} else {
						ElMessage.error(res.msg)
					}
				})
			} else {
				//未登录
				if (type == 'goods') {
					//单个商品
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map(cartItem => {
								if (cartItem.goodsId == curCartStoreGoodsId.goodsId) {
									cartItem.isChecked = !isCheckedState
								}
							})
						})
					})
					curStoreCartSelChecked()
				} else if (type == 'store') {
					//单个店铺
					cartData.data.storeCartGroupList.map(storeItem => {
						if (storeItem.storeId == curCartStoreGoodsId.storeId) {
							storeItem.checkedAll = !isCheckedState
						}
					})
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map(cartItem => {
								if (storeItem.storeId == curCartStoreGoodsId.storeId) {
									cartItem.isChecked = storeItem.checkedAll
								}
							})
						})
					})
					curStoreCartSelChecked()
				} else if (type == 'all') {
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.checkedAll = !isCheckedState
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map(cartItem => {
								cartItem.isChecked = !isCheckedState
							})
						})
					})
					cartData.data.checkedAll = !isCheckedState
				}
				colculationOperation()
				updateLocCartData(cartData.data)
			}
		}

		// //移入收藏夹 cartId: 商品购物车id集(当前商品购物车id)
		// const moveCartGoods = cartId => {
		// 	let params = {
		// 		cartIds: cartId
		// 	}
		// 	proxy
		// 		.$post('v3/business/front/cart/moveToCollection', params)
		// 		.then(res => {
		// 			if (res.state == 200) {
		// 				cartData.data = res.data
		// 				cartData.data = proxy.$calculateSubtotal(cartData.data)
		// 				acLabelMarkify()
		// 				ElMessage.success(L['移入收藏夹成功！'])
		// 				store.commit('updateCartListData', cartData.data)
		// 			} else {
		// 				ElMessage.error(res.msg)
		// 			}
		// 		})
		// 	// let moveOK = 1;
		// 	// if(moveOK = 0){
				
		// 	// }else{
		// 	// 	ElMessage.warning('该功能暂未开发')
		// 	// }
			
		// }
		const moveCartGoods = async () => {
    // 收集所有选中的商品的 cartId
    let selectedCartIds = [];
    cartData.data.storeCartGroupList.forEach(storeItem => {
        storeItem.promotionCartGroupList.forEach(promotItem => {
            promotItem.cartList.forEach(cartItem => {
                if (cartItem.isChecked) {
                    selectedCartIds.push(cartItem.cartId);
                }
            });
        });
    });

    if (selectedCartIds.length === 0) {
        ElMessage.warning('请至少选择一件商品');
        return;
    }

    try {
        // 发送请求移入收藏夹
        const params = { 
            cartIds: selectedCartIds.join(',') // 将数组转换为逗号分隔的字符串
        };
        const res = await proxy.$post('v3/business/front/cart/moveToCollection', params);

        if (res.state === 200) {
            // 更新并计算新的购物车数据
            const updatedCartData = proxy.$calculateSubtotal(res.data);
            cartData.data = updatedCartData;
            acLabelMarkify();
            
            ElMessage.success(L['移入收藏夹成功！']);
            
            // 更新 Vuex store 中的购物车数据
            store.commit('updateCartListData', updatedCartData);
        } else {
            ElMessage.error(res.msg || '未知错误');
        }
    } catch (error) {
        // 捕获任何网络或请求错误
        ElMessage.error('网络请求失败，请稍后重试');
        console.error('移入收藏夹失败:', error);
    }
};

		//删除商品 type:'goods'单个商品 curCartItem: 当前商品信息    batch:批量
		const delCartGoods = (type, curCartItem) => {
			if (store.state.loginFlag) {
				//已登录
				if (type == 'goods') {
					delGoodsCartIds.value = curCartItem.cartId
					curCartItem.promotionModel = false
				} else if (type == 'batch') {
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map(cartItem => {
								if (cartItem.isChecked == 1) {
									delGoodsCartIds.value += cartItem.cartId + ','
								}
							})
						})
					})
					delGoodsCartIds.value = delGoodsCartIds.value.substring(
						0,
						delGoodsCartIds.value.length - 1
					)
				}
			} else {
				//未登录
				if (type == 'goods') {
					delType.value = 'goods'
					delGoodsCartIds.value = curCartItem.goodsId
				} else if (type == 'batch') {
					delType.value = 'batch'
				}
			}
			chosenGoodsModel.value = false
			confirmDelGoodsModel()
		}

		//确定删除商品
		const confirmDelGoodsModel = () => {
			if (store.state.loginFlag) {
				// 已登录
				let params = {
					cartIds: delGoodsCartIds.value
				}
				let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
				proxy.$post('v3/business/front/cart/deleteCarts', params,config).then(res => {
					if (res.state == 200) {
						cartData.data = res.data
						ElMessage.success(L['删除成功！'])
						// proxy.$getLoginCartListData();
						closePromotionModel()
						acLabelMarkify()
						updateLocCartData(cartData.data)
					} else {
						ElMessage.error(res.msg)
					}
				})
			} else {
				// 未登录
				if (delType.value == 'goods') {
					//单个商品删除
					cartData.data.storeCartGroupList.map((storeItem, storeIndex) => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map((cartItem, cartIndex) => {
								if (cartItem.goodsId == delGoodsCartIds.value) {
									promotItem.cartList.splice(cartIndex, 1)
								}
							})
							if (promotItem.cartList.length == 0) {
								storeItem.promotionCartGroupList = []
							}
							if (storeItem.promotionCartGroupList.length == 0) {
								cartData.data.storeCartGroupList.splice(storeIndex, 1)
							}
						})
					})
				} else if (delType.value == 'batch') {
					//批量删除
					let curSelGoods = [] //选中的商品
					cartData.data.storeCartGroupList.map(storeItem => {
						storeItem.promotionCartGroupList.map(promotItem => {
							curSelGoods = promotItem.cartList.filter(
								cartItem => cartItem.isChecked == 1
							)
						})
					})
					cartData.data.storeCartGroupList.map((storeItem, storeIndex) => {
						storeItem.promotionCartGroupList.map(promotItem => {
							promotItem.cartList.map((cartItem, cartIndex) => {
								curSelGoods.map(curSelGoodsItem => {
									if (cartItem.goodsId == curSelGoodsItem.goodsId) {
										promotItem.cartList.splice(cartIndex, 1)
									}
								})
							})
							if (promotItem.cartList.length == 0) {
								storeItem.promotionCartGroupList = []
							}
							if (storeItem.promotionCartGroupList.length == 0) {
								cartData.data.storeCartGroupList.splice(storeIndex, 1)
							}
						})
					})
					curStoreCartSelChecked()
				}
				ElMessage.success(L['删除成功！'])
				cartData.data = proxy.$cartDataNum(cartData.data);
				updateLocCartData(cartData.data)
			}
		}

		//打开清空失效商品弹框
		const clearInvalidGoods = () => {
			clearInvalidGoodsModel.value = true
		}
		//确定清空失效商品
		const confirmClearInvalidModel = () => {
			let params = {}
			proxy.$post('v3/business/front/cart/emptyInvalid', params).then(res => {
				if (res.state == 200) {
					cartData.data.invalidList = []
					ElMessage.success(L['清空失效商品成功！'])
				} else {
					ElMessage.error(res.msg)
				}
			})
			clearInvalidGoodsModel.value = false
		}
		//取消清空失效商品
		const cancelClearInvalidModel = () => {
			clearInvalidGoodsModel.value = false
		}

		//去商品详情页
		const goGoodsDetail = productId => {
			proxy.$goGoodsDetail(productId)
		}

		//去结算
		const goBuy = () => {
			if (store.state.loginFlag) {
				if (cartData.data.totalCheck > 0) {
					router.push({ path: '/buy/confirm', query: { ifcart: true } })
				} else {
					ElMessage(L['结算商品不能为空！'])
				}
			} else {
				//未登录提示登录
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
			}
		}
		//关闭登录弹框
		const closeLoingModal = () => {
			loginModalVisibleFlag.value = false
		}

		//修改选择促销活动 e:v-model的值，cartItem,当前项商品
		const changePromotion = (e, curCartItem) => {
			curPromotion.value = e
			curPromotionCartItem.data = curCartItem
		}

		//点击促销，显示促销选择弹框
		const promotionShow = cartItem => {
			curPromotionGoodsProductId.value = cartItem.productId

			// curPromotion.value = cartItem.goodsPromotionId;

			let findProIm = cartItem.promotionList.findIndex(
				proIm =>
					proIm.promotionId == cartItem.promotionId &&
					proIm.promotionType == cartItem.promotionType
			)
			if (findProIm > -1) {
				curPromotion.value = cartItem.promotionList[findProIm].goodsPromotionId
			} else {
				curPromotion.value = ''
			}

			cartData.data &&
				cartData.data.storeCartGroupList &&
				cartData.data.storeCartGroupList.map(storeItem => {
					storeItem.promotionCartGroupList.map(promotItem => {
						promotItem.cartList.map(cartItem => {
							cartItem.promotionModel = false
						})
						let curPromoGoods = []
						curPromoGoods = promotItem.cartList.filter(
							cartItem => cartItem.productId == curPromotionGoodsProductId.value
						)
						if (curPromoGoods && curPromoGoods.length > 0) {
							curPromoGoods[0].promotionModel = true
						}
					})
				})
		}

		//确定选择促销活动
		const selPromotion = () => {
			if (JSON.stringify(curPromotionCartItem.data) != '{}') {
				let curPromotionItem = []
				curPromotionItem = curPromotionCartItem.data.promotionList.filter(
					promotionItem => promotionItem.goodsPromotionId == curPromotion.value
				)
				if (curPromotionItem.length > 0) {
					let params = {
						cartId: curPromotionCartItem.data.cartId,
						promotionDescription: curPromotionItem[0].promotionDes.replace(
							/<font color='--color_main'>|<\/font>/g,
							''
						),
						promotionId: curPromotionItem[0].promotionId,
						promotionType: curPromotionItem[0].promotionType
					}
					proxy
						.$post('v3/business/front/cart/changePromotion', params)
						.then(res => {
							if (res.state == 200) {
								cartData.data = res.data
								cartData.data = proxy.$calculateSubtotal(cartData.data)
								acLabelMarkify()
								closePromotionModel()
							} else {
								ElMessage.error(res.msg)
							}
						})
				}
			} else {
				closePromotionModel()
			}
		}

		//关闭促销弹框
		const closePromotionModel = () => {
			cartData.data &&
				cartData.data.storeCartGroupList &&
				cartData.data.storeCartGroupList.map(storeItem => {
					storeItem.promotionCartGroupList.map(promotItem => {
						promotItem.cartList.map(cartItem => {
							cartItem.promotionModel = false
						})
					})
				})
			updateLocCartData(cartData.data)
		}

		//取消选择促销活动
		const cancelPromotion = () => {
			closePromotionModel()
		}

		//去首页
		const goIndex = () => {
			router.push({ path: '/' })
		}

		//打开优惠券弹框
		const openCouponModel = (storeId, index, type) => {
			switch (type) {
				case 'open': {
					curStoreId.value = storeId ? storeId : curStoreId.value

					if (cartData.data.storeCartGroupList[index].showCoupon) {
						cartData.data.storeCartGroupList[index].showCoupon = false
						curStoreId.value = -1
					} else {
						//获取优惠券
						let params = {
							storeId: curStoreId.value,
							current: curCouponPage.value,
							pageSize: couponPageSize.value
						}
						proxy
							.$get('v3/promotion/front/coupon/storeCouponList', params)
							.then(res => {
								if (res.state == 200) {
									couponList.data = res.data
								}
							})
						cartData.data.storeCartGroupList[index].showCoupon = true
					}
					break
				}

				case 'get': {
					//获取优惠券
					let params = {
						storeId: curStoreId.value,
						current: curCouponPage.value,
						pageSize: couponPageSize.value
					}
					proxy
						.$get('v3/promotion/front/coupon/storeCouponList', params)
						.then(res => {
							if (res.state == 200) {
								couponList.data = res.data
							}
						})
				}
			}
		}
		//关闭优惠券弹窗
		const closeCouponModel = index => {
			cartData.data.storeCartGroupList[index].showCoupon = false
		}
		//上一页优惠券
		const handlePrevCilickChangeCoupon = () => {
			curCouponPage.value--
			openCouponModel(null, null, 'get')
		}
		//下一页优惠券
		const handleNextCilickChangeCoupon = () => {
			curCouponPage.value++
			openCouponModel(null, null, 'get')
		}
		//当前页数优惠券
		const handleCurrentChangeCoupon = () => {
			openCouponModel(null, null, 'get')
		}

		//批量删除商品
		const delBatchGoods = () => {
			let antiNum = 0
			cartData.data.storeCartGroupList.map(storeItem => {
				storeItem.promotionCartGroupList.map(promotItem => {
					if (
						promotItem.cartList.filter(cartItem => cartItem.isChecked == 1)
							.length > 0
					) {
						antiNum++
					}
				})
			})

			if (antiNum == 0) {
				ElMessage.warning('请选择要删除的商品')
			} else {
				chosenGoodsModel.value = true
			}
		}

		//商品的增值服务
		const addService = (params) =>{
				let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
						proxy.$post('v3/business/front/cart/changeCart', params,config).then(res => {
					if (res.state == 200) {
						// cartData.data = res.data
						// ElMessage.success(L['删除成功！'])
						// updateLocCartData(cartData.data)
						console.log("增值服务========>",res.data)
					} else {
						ElMessage.error(res.msg)
					}
				})		
		}
		

		const acLabelMarkify = () => {
			cartData.data.storeCartGroupList.map(storeItem => {
				storeItem.promotionCartGroupList.map(promotItem => {
					if (promotItem.promotionDes) {
						promotItem.promotionDes = promotItem.promotionDes.replace(
							/<(.+?)>/g,
							function (num) {
								return "<i class='markfied'>" + num.slice(1, num.length - 1) + "</i>"
							}
						)
						promotItem.promotionDes = promotItem.promotionDes.replace(
							/x[\d]/g,
							function (num) {
								return "<i class='markfied'>" + num + "</i>"
							}
						)
					}

					promotItem.cartList.map(cartItem => {
						cartItem.promotionList.map(listItem => {
							listItem.promotionDes = listItem.promotionDes.replace(
								/<(.+?)>/g,
								function (num) {
									return "<i class='markfied'>" + num.slice(1, num.length - 1) + "</i>"
								}
							)
							listItem.promotionDes = listItem.promotionDes.replace(
								/x[\d]/g,
								function (num) {
									return "<i class='markfied'>" + num + "</i>"
								}
							)
						})
					})
				})
			})
		}

		const kefu = cartGroupItem => {
			if (store.state.loginFlag) {
				let chatInfo = {
					storeId: cartGroupItem.storeId,
					vendorAvatar: cartGroupItem.storeLogo,
					storeName: cartGroupItem.storeName,
					source: '从购物车页进入',
					sourceType: 'cart',
					showData: {}
				}
				store.commit('saveChatBaseInfo', chatInfo)

				let newWin = router.resolve({
					path: '/service',
					query: {
						vid: cartGroupItem.storeId
					}
				})

				window.open(newWin.href, '_blank')
			} else {
				//未登录提示登录
				// loginModalVisibleFlag.value = true
				goToByPush("/login", {});
			}
		}

		const handleKey = e => {
			if (e.keyCode == 100) {
				return false;
			}
		}

		const goToByPush =(type,param = {})  => {
			router.push({
        path: type,
        query: param
      });
		}

		// 截断文本的方法
		const truncateText = (text, length) => {
            return text.length > length ? text.slice(0, length) + '...' : text;
        };

				// 计算是否为每行最后一个元素
		const itemsPerRow = 2; // 假定每行两个优惠券
		const isLastInRow = (index) => {
			return (index + 1) % itemsPerRow === 0;
		}

		// 当前选中的 cartItem
		const currentCartItem = ref(null);

		// 打开增值服务弹框
		const openAddSer = (cartItem) =>{
			addSerVisible.value = true,
			// 存储当前的 cartItem
  		currentCartItem.value = cartItem;
			getIncrService(cartItem.productId,cartItem.increaseServiceId)
			// 如果当前商品已有选中的增值服务，则预制选中它们
			if (cartItem.increments && Array.isArray(cartItem.increments)) {
				cartItem.increments.forEach((service,serviceIndex) => {
					// 假设service.id是服务项的唯一标识符，service.productId是关联的商品ID
					selectedItems[serviceIndex] = service.productId;
				});
			}
			
		}
		//选择增值服务
		const confirmAddSer = () =>{
			// 收集所有选中的 productId
			const selectedProductIds = Object.entries(selectedItems).map(([serviceIndex, productId]) => ({
      productId: parseInt(productId, 10),
			buyNum:1
			}));

			// 构建请求体
			const params = {
				cartId: currentCartItem.value.cartId, // 使用当前 cartItem 的 cartId
				cartAddDTO: {
					increments: selectedProductIds,
				},
			};
			
			addService(params);
			addSerVisible.value = false
			getCartData()
		}

		const selectedItems = reactive({});

		// 选择或取消选择增值服务项中的商品
		function chooseincrService(incrServiceIndex, incrSerInfoItem) {
			const serviceId = incrServiceIndex;
			const productId = incrSerInfoItem.productId;

			// 如果已经选择了其他的商品，取消之前的选中状态，并设置新的选中商品
			if (selectedItems[serviceId] !== productId) {
				selectedItems[serviceId] = productId;
			} else {
				// 如果再次点击已选中的商品，可以选择取消选中
				delete selectedItems[serviceId];
			}
		}

		// 检查某个商品是否被选中
		const isSelected = computed(() => (serviceIndex, productId) => {
			return selectedItems[serviceIndex] === productId;
		});
		// 检查是否有任何商品被选中
		const isAnyItemSelected = computed(() => (serviceIndex) => {
			return Object.prototype.hasOwnProperty.call(selectedItems, serviceIndex);
		});


		/*增值服务*/
		const getIncrService=(productId,increaseServiceId)=>{
			let param={
				productId:productId,
				increaseServiceId:increaseServiceId,
				// storeId:vid.value
			}
			proxy.$post('v3/promotion/front/increaseService/commodityList',param,'json').then(res=>{				
				
				//just for test
				//res=getTestIncrService()
								
				if(res.state==200){
					incrServiceList.data = res.data;
					console.log("zengzhifuwu========>",incrServiceList.data)	
					// incrServicecommodityList.data= incrServiceList.data.commodityList.data
					// console.log('zengzhiContent',incrServicecommodityList.data)
				} else {
					ElMessage.error(res.msg)	
				}
				
				
			})
			
		}

		// 打开配置弹框
		const openSpecBox = async (cartItem) => {
			currentCartItem.value = cartItem;
			specVisible.value = true;

			try {
				// 等待获取规格信息完成
				await getSpecInfo(cartItem.goodsId);

				// 尝试根据productId预选中规格项
				const found = SpecInfoList.data.some(specInfo => {
					if (specInfo.productId === cartItem.productId) {
						selectedSpec.value = specInfo;
						return true; // 终止循环
					}
				});

				if (!found) {
					console.warn(`未找到与 productId ${cartItem.productId} 匹配的规格项`);
				}
			} catch (error) {
				console.error("Failed to load spec info:", error);
				ElMessage.error("加载规格信息失败");
			}
		};

		// 获取规格信息
		const getSpecInfo = (goodsId) => {
			let params = {
				goodsId: goodsId
			};
			
			// 返回Promise以支持async/await
			return proxy.$get('v3/goods/front/goods/getProductInfoList', params)
				.then(res => {
					if (res.state == 200) {
						SpecInfoList.data = res.data;
						console.log("guige========>", SpecInfoList.data);
					} else {
						console.error("获取规格信息失败:", res.msg);
						ElMessage.error(res.msg);
						throw new Error(res.msg); // 抛出错误以便catch处理
					}
				})
				.catch(error => {
					console.error("网络请求或处理过程中出现错误:", error);
					throw error; // 重新抛出错误以确保async/await能捕捉到
				});
		};

		//选择规格
		const confirmSpec = () =>{
			if (!selectedSpec.value || !currentCartItem.value.cartId) {
        console.error("请选择规格");
        // 可以在这里给用户显示一个错误消息
        return;
    }
			// 构建请求体
			const params = {
      cartId: currentCartItem.value.cartId,
			cartAddDTO: {
				buyNum:1,
				productId: selectedSpec.value.productId, // 确保这里使用正确的字段名
				},
   		 };
			modSpec(params);
			specVisible.value = false;
			getCartData()
		}
		//商品的规格
		const modSpec = (params) =>{
				let config = {
                headers: {
                    "Content-Type": "application/json",
                    // 'Authorization': "Bearer " + localStorage.getItem("access_token"),
                },
            };
						proxy.$post('v3/business/front/cart/changeCart', params,config).then(res => {
					if (res.state == 200) {
						// cartData.data = res.data
						// ElMessage.success(L['删除成功！'])
						// updateLocCartData(cartData.data)
						console.log("商品规格========>",res.data)
					} else {
						ElMessage.error(res.msg)
					}
				})		
		}
		// 假设这是你的默认规格
		// const defaultSpec = {
		// 		productId: 123, // 根据实际情况调整
		// 		// 添加其他需要的字段
		// };

		// 定义 selectedSpec 并赋予默认值
		// const selectedSpec = ref(defaultSpec);
		const selectedSpec = ref(null);

		// 选择或取消选择规格项
		function chooseSpec(SpecInfoItem) {
			// 更新选中状态
			selectedSpec.value = SpecInfoItem;
		}

		// 检查某个规格项是否被选中
		const isSpecSelected = computed(() => (SpecInfoItem) => {
			return selectedSpec.value === SpecInfoItem;
		});

		//打开优惠明细弹框
		const openCouponInfo = () =>{
			couponInfo.value = true
		}
		//打开优惠券弹框
		const openCouponBox = () =>{
			couponVisible.value = true
		}
		//领取优惠券
		const getCouponInfo = (couponItem) => {
			let params = {
				couponId:couponItem.couponId
			}
			proxy.$get('v3/promotion/front/coupon/receiveCoupon', params)
				.then(res => {
					if (res.state == 200) {
						// 更新优惠券的状态为已领取
						couponItem.receiveFlag = 1; // 根据后端响应更新 receiveFlag
						// SpecInfoList.data = res.data
						console.log("youhuiquan========>",res.data)
						getCartData();
					}
					else {
					ElMessage.error(res.msg)	
				}
			})
		}

		//关闭优惠券弹框
		const closeCouponInfo = () =>{
			couponVisible.value = false;
		}

		//暴露的变量及方法
		return {
			handleKey,
			L,
			itemsPerRow,
			isLastInRow,
			token,
			cartData,
			addService,
			confirmAddSer,
			editNum,
			goToByPush,
			clearInvalidGoods,
			closeCouponInfo,
			truncateText,
			clearInvalidGoodsModel,
			confirmClearInvalidModel,
			cancelClearInvalidModel,
			changeSelectState,
			confirmDelGoodsModel,
			moveCartGoods,
			delCartGoods,
			delGoodsCartIds,
			goGoodsDetail,
			goBuy,
			changePromotion,
			curPromotion,
			selPromotion,
			curPromotionCartItem,
			cancelPromotion,
			goIndex,
			couponModel,
			openCouponModel,
			closeCouponModel,
			couponList,
			cartListData,
			loginModalVisibleFlag,
			closeLoingModal,
			optionsBtn,
			optionsBtnTop,
			windowHeight,
			optionsBtnShow,
			promotionShow,
			curPromotionGoodsProductId,
			curCouponPage,
			couponPageSize,
			handlePrevCilickChangeCoupon,
			handleNextCilickChangeCoupon,
			handleCurrentChangeCoupon,
			curStoreId,
			elementScrollTop,
			delBatchGoods,
			chosenGoodsModel,
			kefu,
			couponVisible,
			addSerVisible,
			specVisible,
			openAddSer,
			openSpecBox,
			couponInfo,
			openCouponInfo,
			getIncrService,
			incrServiceList,
			getSpecInfo,
			SpecInfoList,
			confirmSpec,
			modSpec,
			chooseSpec,
			isSpecSelected,
			productId,
			// incrServicecommodityList,
			selectedItems,
			chooseincrService,
			isSelected,
			isAnyItemSelected,
			currentCartItem,
			confirmSpec,
			selectedSpec,
			openCouponBox,
			getCouponInfo,
			isDisabledInvalidSle
			
		}
	}
}
</script>

<style lang="scss">
@import '../../style/base.scss';
@import '../../style/iconfont.css';
@import '../../style/cartIndex.scss';


.markfied {
	font-style: normal;
	color: var(--color_main);
}

.option_promotion {
	.el-radio {
		margin-bottom: 15px;
		white-space: unset;
		vertical-align: top;
		margin-right: 20px;
	}

	.el-radio__label {
		width: 240px;

		display: inline-block;
		word-break: break-all;
		vertical-align: top;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: var(--color_main);
		background: var(--color_main);
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: var(--color_main);
	}



	.promotion_btn {
		span {
			width: 40px;
			height: 20px;
			background: var(--color_main_bg);
			border-radius: 3px;
			font-size: 12px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
			display: inline-block;
			text-align: center;
			line-height: 20px;
			font-weight: 600;
			cursor: pointer;

			&:nth-child(2) {
				margin-left: 40px;
				background: #ffffff;
				color: var(--color_main);
			}
		}
	}

	.el-overlay {
		background-color: rgba(0, 0, 0, 0.3);
	}
}

.sld_paginations .el-pager li.active {
	color: var(--color_coupon_main) !important;
}

.sld_paginations .el-pager li:hover {
	color: var(--color_coupon_main) !important;
}

.sld_paginations .el-input__inner:focus {
	border-color: var(--color_coupon_main);
}

.sld_paginations .el-pagination .btn-prev:hover {
	color: var(--color_coupon_main) !important;
}

.sld_paginations .el-pagination .btn-next:hover {
	color: var(--color_coupon_main) !important;
}

.checkboxbox{
  display: inline-block;
  position: relative;
	width: 20px;
}

.checkboxbox input[type="checkbox"] {
  /* 隐藏原始的复选框 */
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
	width: 20px; /* 根据图片大小调整 */
  height: 20px; /* 根据图片大小调整 */
}

.checkboxbox .checkbox-custom {
	background-image: url('../../assets/cart/pro_no.png'); /* 替换为你的未选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 20px; /* 根据图片大小调整 */
  height: 20px; /* 根据图片大小调整 */
  display: inline-block;
  cursor: pointer;
}

.checkboxbox input[type="checkbox"]:checked + .checkbox-custom {
	background-image: url('../../assets/cart/pro_yes.png'); /* 替换为你的选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
	width: 20px; /* 根据图片大小调整 */
  height: 20px; /* 根据图片大小调整 */
}

//失效商品选中框
.checkboxboxInvalid{
  display: inline-block;
  position: relative;
	width: 20px;
}

.checkboxboxInvalid input[type="checkbox"] {
  /* 隐藏原始的复选框 */
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
	width: 20px; /* 根据图片大小调整 */
  height: 20px; /* 根据图片大小调整 */
}

.checkboxboxInvalid .checkbox-custom-invalid {
	background-image: url('../../assets/cart/invalid_sel.png'); /* 替换为你的未选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 20px; /* 根据图片大小调整 */
  height: 20px; /* 根据图片大小调整 */
  display: inline-block;
  cursor: pointer;
}

.checkboxboxInvalid input[type="checkbox"]:checked + .checkbox-custom-invalid {
	background-image: url('../../assets/cart/pro_yes.png'); /* 替换为你的选中图片路径 */
	background-size: cover; /* 确保图片覆盖整个区域 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
	width: 20px; /* 根据图片大小调整 */
  height: 20px; /* 根据图片大小调整 */
}

.el-popover.el-popper{
		width: 269px;
		height: 125px;
		display: flex;
    justify-content: center;
    align-items: flex-start;
		padding: 0px;
}

/* 使用 :deep() 来修改内部样式 */
.el-popconfirm .el-button--primary{
  width: 100px;
	height: 34px;
	background: #1E7CFF!important;
	border-radius: 2px 2px 2px 2px;
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 15px;
	color: #FFFFFF;
}

.el-popconfirm .el-button--text{
  width: 100px;
	height: 34px;
	border-radius: 1px 1px 1px 1px;
	border: 1px solid #E0E0E0;
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 15px;
	color: #888E98;
	
}

.el-popconfirm .el-popconfirm__main{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 15px;
	color: #000000;
	line-height: 24px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 20px;
	margin-bottom: 30px;
}
.el-button+.el-button {
    margin-left: 20px;
}


.el-popover.coupon_info_popover.el-popper{
	width: 450px;
	height: 280px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 16px 16px 27px 30px;
}
.coupon_title{
	width: 100%;
	margin-bottom: 6px;
	span{
		font-family: Microsoft YaHei,Microsoft YaHei ;
		font-weight: 400;
		font-size: 18px;
		color: #000000;
		line-height: 22px;
	}
	img{
		width: 40px;
		height: 40px;
	}
}
.name_info_coupon{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 16px;
	color: #888E98;
	line-height: 22px;
}
.name_info_coupon_total{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
	line-height: 22px;
}
.price_coupon{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 16px;
	color: #DF443B;
	line-height: 22px;
	margin-right: 14px;
}
.price_coupon_total{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 500;
	font-size: 16px;
	color: #DF443B;
	line-height: 22px;
	margin-right: 14px;
}
.coupon_item_info{
	width: 100%;
	margin-bottom: 10px;
}
.coupon_item_info_top{
	width: 100%;
	margin-top: 20px;
	padding-bottom: 10px;
	border-bottom: 1px solid #EAEDF0;
}

.coupon_more_custom{
	width: 950px;
	height: 480px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	background: #FFFFFF;
	box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.15);
	border-radius: 0px 0px 0px 0px;
}
.coupon_more_custom .el-dialog__header{
	padding: 0px;
	height: 80px;
	padding-top: 50px;
}
.coupon_more_custom .el-dialog__header .el-dialog__title{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 500;
	font-size: 20px;
	color: #000000;
	line-height: 30px;
	margin-top: 50px;
}
.coupon_more_custom .el-dialog__header .el-icon {
    --font-size: 26px; 
}
.coupon_more_custom .el-dialog__body{
	padding: 0px;
	padding: 20px 4px 0px 30px;
	padding-bottom: auto;
}
.coupon_more_custom .el-dialog__footer{
	padding: 0px;
	margin-bottom: 20px;
	margin-top: auto;
}
.coupon_more_custom .el-dialog__footer .el-button--primary{
	width: 150px;
	height: 46px;
	background: #1E7CFF!important;
	border-radius: 2px 2px 2px 2px;
	border: 1px solid #1E7CFF!important;
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 18px;
	color: #FFFFFF;
	text-align: center;
	}

	//优惠券
	.coupon_container{
		display: flex;
  	flex-wrap: wrap; /* 允许换行 */
		max-height: 394px; /* 设置一个合适的最大高度 */
    overflow-y: auto;  /* 当内容超出容器高度时，显示滚动条 */
		.coupon_item_more{
		width: 435px;
		height: 140px;
		display: flex;
		margin-bottom: 20px;
		margin-right: 20px;
			.coupon_more_item{
			width: 435px;
			height: 140px;
			padding: 27px 30px 27px 30px;
			background: transparent;
			background-image: url('../../assets/cart/coupon_bg.png');
			background-repeat: no-repeat;
			background-size: cover;
			.more_left{
				.more_top{
					margin-bottom: 4px;
					.coupon_mon{
						font-family: Microsoft YaHei,Microsoft YaHei ;
						font-weight: 600;
						font-size: 20px;
						color: #DF443B;
						line-height: 40px;
						margin-right: 15px;
						
					}
					.coupon_lim{
						height: 18px;
						background: rgba(223,68,59,0.1);
						font-family: Microsoft YaHei,Microsoft YaHei ;
						font-weight: 400;
						font-size: 12px;
						color: #DF443B;
						line-height: 18px;
						text-align: center;
						padding-left: 4px;
						padding-right: 4px;
					}
				}
				.more_center{
					font-family: Microsoft YaHei,Microsoft YaHei ;
					font-weight: 400;
					font-size: 15px;
					color: #000000;
					line-height: 24px;
				}
				.more_bottom{
					font-family: Microsoft YaHei,Microsoft YaHei ;
					font-weight: 400;
					font-size: 12px;
					color: #888E98;
					line-height: 18px;
				}
			}
			.more_right{
				font-family: Microsoft YaHei,Microsoft YaHei ;
				font-weight: 400;
				font-size: 18px;
				color: #FFFFFF;
				line-height: 35px;
				text-align: center;
				width: 84px;
				height: 36px;
				background: linear-gradient( 270deg, #E13535 0%, #EC7556 100%);
				border-radius: 2px 2px 2px 2px;
				img{
					width: 30px;
				height: 30px;
				}
				&.no_receive {
						opacity: 0.5;
						pointer-events: none;
				}
			}
		}
	}
	.coupon_item_more.last-in-row {
		margin-right: 0; /* 移除每行最后一个项目的右边距 */
	}
	}
	/* 滚动条整体部分 */
.coupon_container::-webkit-scrollbar {
    width: 4px; /* 设置滚动条的宽度 */
}

/* 滚动条轨道 */
.coupon_container::-webkit-scrollbar-track {
    background: #FFFFFF ; /* 轨道背景颜色 */
    border-radius: 2px;
}

/* 滑块 */
.coupon_container::-webkit-scrollbar-thumb {
    background: #E7E9EB; /* 滑块背景颜色 */
    border-radius: 2px;
		max-height: 72px; /* 设置滑块的最小高度 */
}

/* 鼠标悬停时滑块的颜色 */
.coupon_container::-webkit-scrollbar-thumb:hover {
    background: #E7E9EB;
}

/* 滚动条两端的按钮（如果有的话） */
.coupon_container::-webkit-scrollbar-button {
    display: none; /* 如果不需要按钮，可以隐藏它们 */
}

/* 角落部分，即两个滚动条相接的角落 */
.coupon_container::-webkit-scrollbar-corner {
    background: transparent;
}
	
//增值服务
.add_ser_cpontainer{
	display: flex;
	flex-wrap: wrap; /* 允许换行 */
	max-height: 394px; /* 设置一个合适的最大高度 */
	overflow-y: auto;  /* 当内容超出容器高度时，显示滚动条 */
}
/* 滚动条整体部分 */
.add_ser_cpontainer::-webkit-scrollbar {
    width: 4px; /* 设置滚动条的宽度 */
}

/* 滚动条轨道 */
.add_ser_cpontainer::-webkit-scrollbar-track {
    background: #FFFFFF ; /* 轨道背景颜色 */
    border-radius: 2px;
}

/* 滑块 */
.add_ser_cpontainer::-webkit-scrollbar-thumb {
    background: #E7E9EB; /* 滑块背景颜色 */
    border-radius: 2px;
		max-height: 72px; /* 设置滑块的最小高度 */
}

/* 鼠标悬停时滑块的颜色 */
.add_ser_cpontainer::-webkit-scrollbar-thumb:hover {
    background: #E7E9EB;
}

/* 滚动条两端的按钮（如果有的话） */
.add_ser_cpontainer::-webkit-scrollbar-button {
    display: none; /* 如果不需要按钮，可以隐藏它们 */
}

/* 角落部分，即两个滚动条相接的角落 */
.add_ser_cpontainer::-webkit-scrollbar-corner {
    background: transparent;
}
.add_service_custom{
		width: 950px;
		height: 580px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		background: #FFFFFF;
		box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.15);
		border-radius: 0px 0px 0px 0px;
	}
.add_service_custom .el-dialog__header{
	padding: 0px;
	height: 80px;
	padding-top: 50px;
}
.add_service_custom .el-dialog__header .el-dialog__title{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 500;
	font-size: 20px;
	color: #000000;
	line-height: 30px;
	margin-top: 50px;
}
.add_service_custom .el-dialog__header .el-icon {
    --font-size: 26px; 
}
.add_service_custom .el-dialog__body{
	padding: 0px;
	padding: 20px 4px 0px 30px;
	padding-bottom: auto;
}
.add_service_custom .el-dialog__footer{
	padding: 0px;
	margin-bottom: 20px;
	margin-top: auto;
}
.add_service_custom .el-dialog__footer .el-button--primary{
	width: 150px;
	height: 46px;
	background: #1E7CFF!important;
	border-radius: 2px 2px 2px 2px;
	border: 1px solid #1E7CFF!important;
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 18px;
	color: #FFFFFF;
	text-align: center;
	}

.add_postpone{
	margin-bottom: 10px;
	.add_header{
		margin-bottom: 20px;
		width: 890px;
			.add_title{
				font-family: Microsoft YaHei,Microsoft YaHei ;
				font-weight: 500;
				font-size: 15px;
				color: #000000;
				line-height: 22px;
			}
			.add_info{
				font-family: Microsoft YaHei,Microsoft YaHei ;
				font-weight: 400;
				font-size: 15px;
				color: #888E98;
				line-height: 22px;
			}
	}
	.add_container{
		display: flex;
  	flex-wrap: wrap; /* 允许换行 */
		.add_item_row{
				width: 435px;
				// height: 54px;
				border-radius: 1px 1px 1px 1px;
				margin-bottom: 20px;
				margin-right: 20px;
			.add_ser_item{
				width: 435px;
				// height: 54px;
				padding: 15px 32px;
				border-radius: 1px 1px 1px 1px;
				border: 1px solid #E0E0E0;
				position: relative;
				.add_left{
					font-family: Microsoft YaHei,Microsoft YaHei ;
					font-weight: 400;
					font-size: 15px;
					color: rgba(0,0,0,0.7);
					line-height: 22px;
					text-align: center;
					// margin-right: 25px;
				}
				.add_left_price{
					color: rgba(0,0,0,0.7);
				}
				
				
				.add_tips{
					width: 140px;
					// padding: 0 18px;
					height: 20px;
					background: #E8F2FF;
					font-family: Microsoft YaHei,Microsoft YaHei ;
					font-weight: 400;
					font-size: 12px;
					color: #1E7CFF;
					line-height: 18px;
					border-radius: 0px 0px 0px 0px;
					text-align: center;
					position: absolute;
					top: -10px;
					right: -1px;
				}
				.add_origin_price{
					font-family: Microsoft YaHei,Microsoft YaHei ;
					font-weight: 400;
					font-size: 12px;
					color: #BDBDBD;
					line-height: 18px;
					text-decoration: line-through;
				}
			}
		}
		.add_item_row.last-in-row {
		margin-right: 0; /* 移除每行最后一个项目的右边距 */
	}
	.add_item_row.selected-item{
		   .add_ser_item{
				border: 1px solid #1E7CFF;
			 }
				.add_left{
				color: #000000;
				
			}
				.add_left_price{
					color: #1E7CFF ;
				}
				.add_tips{
					color: #FFFFFF;
					background: linear-gradient( 90deg, #64A5FF 0%, #1E7CFF 100%);
				}

				}

	}
}	

.spec_main_container{
	display: flex;
	flex-wrap: wrap; /* 允许换行 */
	max-height: 350px; /* 设置一个合适的最大高度 */
	overflow-y: auto;  /* 当内容超出容器高度时，显示滚动条 */
}
/* 滚动条整体部分 */
.spec_main_container::-webkit-scrollbar {
    width: 4px; /* 设置滚动条的宽度 */
}

/* 滚动条轨道 */
.spec_main_container::-webkit-scrollbar-track {
    background: #FFFFFF ; /* 轨道背景颜色 */
    border-radius: 2px;
}

/* 滑块 */
.spec_main_container::-webkit-scrollbar-thumb {
    background: #E7E9EB; /* 滑块背景颜色 */
    border-radius: 2px;
		max-height: 72px; /* 设置滑块的最小高度 */
}

/* 鼠标悬停时滑块的颜色 */
.spec_main_container::-webkit-scrollbar-thumb:hover {
    background: #E7E9EB;
}

/* 滚动条两端的按钮（如果有的话） */
.spec_main_container::-webkit-scrollbar-button {
    display: none; /* 如果不需要按钮，可以隐藏它们 */
}

/* 角落部分，即两个滚动条相接的角落 */
.spec_main_container::-webkit-scrollbar-corner {
    background: transparent;
}

.spec_more_custom{
		width: 950px;
		height: 580px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		background: #FFFFFF;
		box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.15);
		border-radius: 0px 0px 0px 0px;
	}
.spec_more_custom .el-dialog__header{
	padding: 0px;
	height: 80px;
	padding-top: 50px;
}
.spec_more_custom .el-dialog__header .el-dialog__title{
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 500;
	font-size: 20px;
	color: #000000;
	line-height: 30px;
	margin-top: 50px;
}
.spec_more_custom .el-dialog__header .el-icon {
    --font-size: 26px; 
}
.spec_more_custom .el-dialog__body{
	padding: 0px;
	padding: 20px 4px 0px 30px;
	padding-bottom: auto;
}
.spec_more_custom .el-dialog__footer{
	padding: 0px;
	margin-bottom: 20px;
	margin-top: auto;
}
.spec_more_custom .el-dialog__footer .el-button--primary{
	width: 150px;
	height: 46px;
	background: #1E7CFF!important;
	border-radius: 2px 2px 2px 2px;
	border: 1px solid #1E7CFF!important;
	font-family: Microsoft YaHei,Microsoft YaHei ;
	font-weight: 400;
	font-size: 18px;
	color: #FFFFFF;
	text-align: center;
	}

	.spec_title{
		font-family: Microsoft YaHei,Microsoft YaHei ;
		font-weight: 500;
		font-size: 15px;
		color: #000000;
		line-height: 22px;
		display: flex;
		margin-bottom: 20px;
	}

	.spec_container{
		display: flex;
  	flex-wrap: wrap; /* 允许换行 */
		.spec_item_row{
				width: 435px;
				// height: 54px;
				border-radius: 1px 1px 1px 1px;
				margin-bottom: 20px;
				margin-right: 20px;
				border-radius: 1px 1px 1px 1px;
				
			.spec_item{
				width: 435px;
				// height: 54px;
				// border-radius: 1px 1px 1px 1px;
				// border: 1px solid #E0E0E0;
				border: 1px solid #E0E0E0;
				position: relative;
				padding: 17px 25px;
				display: flex;
				justify-content: center;
				align-items: center;
				text-align: center;
				height: 100%;
				.spec_name{
					font-family: Microsoft YaHei,Microsoft YaHei ;
					font-weight: 400;
					font-size: 15px;
					color: rgba(0,0,0,0.7);
					line-height: 22px;
				}
				
			}
		}
		.spec_item_row.last-in-row {
		margin-right: 0; /* 移除每行最后一个项目的右边距 */
	}
	.spec_item_row.selected-item{
		// .spec_item_row{
		// 	border: 1px solid #1E7CFF;
		// }
		.spec_item{
			border: 1px solid #1E7CFF;
		}
		.spec_name{
					color: #000000;
					
				}
	}
	}



	.add_no{
		font-family: Microsoft YaHei,Microsoft YaHei ;
		font-weight: 400;
		font-size: 15px;
		color: #888E98;
		line-height: 24px;
}
.del_custom .el-dialog__footer .el-button--default{
	&:hover{
		border: var(--el-border-base)!important;
		border-color: var(--el-button-border-color, var(--el-border-color-base))!important;
    color: var(--el-button-font-color, var(--el-text-color-regular))!important;
	}

}
.del_custom .el-dialog__footer .el-button--primary{
	// width: 150px;
	// height: 46px;
	background: #1E7CFF!important;
	// border-radius: 2px 2px 2px 2px;
	border: 1px solid #1E7CFF!important;
	// font-family: Microsoft YaHei,Microsoft YaHei ;
	// font-weight: 400;
	// font-size: 18px;
	// color: #FFFFFF;
	// text-align: center;
	}
</style>
